import { Pipe, PipeTransform } from '@angular/core';
import { TIC_NAME, TIC_NAME_NEW_CATEGORY } from '@app/config/tic-name.enum';

@Pipe({
  name: 'ticIndexNew'
})
export class TicIndexNewPipe implements PipeTransform {

  public dataSelectTic = TIC_NAME_NEW_CATEGORY.map(b => { return b });

  transform(value: any): number {
    return this.dataSelectTic.findIndex(x => x.id === value);
  }
}